import { motion } from 'framer-motion'
import { Trans } from 'next-i18next'
import { Button } from '~/components/ui/button'
import { Card } from '~/components/ui/card'
import { useVisitDialog } from '~/domains/spaces/components/space-details/space-visit/space-visit-dialog'
import type { BookingSteps } from '../templates/booking-stepper'

export const VisitInfobox = () => {
	const [, setIsDialogOpen] = useVisitDialog()

	return (
		<Trans
			i18nKey='space:sidebar.visit'
			components={{
				button: (
					<Button
						variant='link'
						size='sm'
						onClick={() => setIsDialogOpen(true)}
					/>
				),
			}}
		/>
	)
}

export const Infobox = ({
	step,
	hasBookingOption,
	isMultidate,
	spaceCapacity,
}: {
	step?: BookingSteps
	hasBookingOption: boolean
	spaceCapacity: number
	isMultidate?: boolean
}) => {
	let comp = null

	// ✍  Renseignez les jours qui vous intéressent, nos équipes vous ferons une offre personnalisée
	if (step === 'start' && !hasBookingOption) {
		comp = <VisitInfobox />
	} else if (step === 'monthSelect') {
		comp = <Trans i18nKey={'space:sidebar.monthSelect'} />
	} else if (step === 'timeSelect') {
		comp =
			spaceCapacity <= 5 ? (
				<Trans i18nKey={'space:sidebar.timeSelect.noExtras'} />
			) : (
				<Trans i18nKey={'space:sidebar.timeSelect.withExtras'} />
			)
	}

	if (isMultidate) {
		comp = <Trans i18nKey={'space:sidebar.monthSelect'} />
	}

	if (!comp) return null

	return (
		<motion.div
			initial={{ opacity: 1 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			className='relative z-30 order-1 touch-none border-slate-200 max-md:rounded-b-none max-md:border-b md:order-2'
		>
			<Card className='p-4 text-sm'>{comp}</Card>
		</motion.div>
	)
}
